import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=71010713&scoped=true&"
import script from "./Signin.vue?vue&type=script&lang=js&"
export * from "./Signin.vue?vue&type=script&lang=js&"
import style0 from "./Signin.vue?vue&type=style&index=0&id=71010713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71010713",
  null
  
)

export default component.exports